import { Button } from 'antd';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import {
  EddShortSteps, EddSteps, stepToPathMap, stepToShortPathMap,
} from '../../constants';
import styles from './index.module.css';

interface ButtonPairProps {
    step: EddSteps | EddShortSteps;
    dataSufficient?: boolean;
    disableNext?: boolean;
    onSubmit?: () => void;
    loading?: boolean;
}

const ButtonPair: FC<ButtonPairProps> = ({
  step,
  dataSufficient = false,
  disableNext = true,
  onSubmit,
  loading,
}) => {
  const dataSufficientBtns = (
    <>
      <Link to={{ pathname: stepToShortPathMap[step]?.back, search: 'type=data-sufficient' }}>
        {step !== EddShortSteps.FIRST && (<Button className={styles.backButton}>← Back</Button>)}
      </Link>
      <Link to={{ pathname: stepToShortPathMap[step]?.forward, search: 'type=data-sufficient' }}>
        <Button type="primary" disabled={disableNext} className={styles.forwardButton} onClick={onSubmit} loading={loading}>{`${step === EddShortSteps.FINAL ? 'Finish' : 'Next'} →`}</Button>
      </Link>
    </>
  );

  const dataInsufficientBtns = (
    <>
      <Link to={stepToPathMap[step].back}>
        {step !== EddSteps.FIRST && (<Button className={styles.backButton}>← Back</Button>)}
      </Link>
      <Link to={stepToPathMap[step].forward}>
        <Button type="primary" disabled={disableNext} className={styles.forwardButton} onClick={onSubmit} loading={loading}>{`${step === EddSteps.FINAL ? 'Finish' : 'Next'} →`}</Button>
      </Link>
    </>
  );

  return (
    <div className={styles.buttons}>
      {dataSufficient ? dataSufficientBtns : dataInsufficientBtns}
    </div>
  );
};

export { ButtonPair };
